module.exports = __webpack_public_path__ + "static/media/module-3000.e27a077e.svg";